import "vue-material-design-icons/styles.css";
import 'izitoast/dist/css/iziToast.min.css'
import 'vue-fineuploader/gallery/gallery.css'

import App from './App';
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueNotifications from 'vue-notifications'
// See https://matteogabriele.gitbooks.io/vue-analytics/
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate'
import iziToast from 'izitoast'
import router from './router';
import store from './store.js';
import { sync } from 'vuex-router-sync';

// Vue use
Vue.use(VueRouter);

function toast({ title, message, type, timeout, cb, icon }) {
  if (type === VueNotifications.types.warn) type = 'warning'
  return iziToast[type]({ title, message, timeout, icon: 'toast-icons', iconText: icon, progressBar: false, position: 'topRight' })
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(Vuelidate);

Vue.use(VueNotifications, options);

const unsync = sync(store, router);

// Vue config
Vue.config.productionTip = false;

Vue.config.devtools = true;

// Init App
/* eslint-disable no-new */
new Vue({
  'el': '#app',
  router,
  store,
  'template': '<App/>',
  'components': { App }
});



// WEBPACK FOOTER //
// ./src/main.js